module.exports = __webpack_public_path__ + "static/media/scrap.e22ad31d.svg";